import { apiInstance } from "store/api/axiosApi";
import { SUPPORT_PLANS } from "store/api/constApi";

export const supportAndPlans = (payload: any) => {
  return apiInstance.post(SUPPORT_PLANS, payload);
};
